import React from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import "./HomepageSingleColumnSection.css";


function HomepageSingleColumnSection() {
  const { homepageSingleColumn, loading } = useGlobalData();
  const displayItems = (homepageSingleColumn || []).filter((item) => item?.title || item?.content);
  if (loading) return null;
  if (displayItems.length === 0) {
    return null;
  }

  return (
    <section className="homepage-single-column-shell">
      <div className="homepage-single-column-grid">
        {displayItems.map((item, index) => (
          <article key={`${item.title}-${index}`} className="homepage-single-column-card">
            <div className="homepage-single-column-title">{item.title}</div>
            <div className="homepage-single-column-content">{item.content}</div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default HomepageSingleColumnSection;